
<dx-popup
    [width]="'600px'"
    [height]="'auto'"
    [showTitle]="true"
    [title]="'SUBMIT-EXTERNAL-CERTIFICATE.TITLE' | translate"
    [dragEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [visible]="true"
    (onHidden)="cancel()"
>
    <div class="popup-content">
        @if(iddResponsiblePerson) {
            <p class="modal-text">{{'SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-DIALOG.TITLE.WITH-PERSON' | translate}}</p>
            <p class="modal-text"><strong>{{ iddResponsiblePerson.firstName + ' ' + iddResponsiblePerson.lastName }}</strong></p>
        } @else {
            <p class="modal-text">{{'SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-DIALOG.TITLE.WITHOUT-PERSON' | translate}}</p>
        }
        <p class="modal-text">{{'SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-DIALOG.CONFIRMATION-PROMPT' | translate}}</p>
        <p class="modal-text">{{'SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-DIALOG.NOTIFICATION-MESSAGE' | translate}}</p>

        @if(certificate.trainingType == TrainingType.IDD || certificate.trainingType == TrainingType.Compliance)
        {
            <div class="modal-text">
                <dx-check-box
                    [(value)]="confirmSubmitting"
                    [text]="(
                        certificate.trainingType == TrainingType.IDD 
                            ? ('SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-TEXT.IDD-TRAINING' | translate) 
                            : ('SUBMIT-EXTERNAL-CERTIFICATE.CONFIRMATION-TEXT.COMPLIANCE-TRAINING' | translate)
                    )"
                ></dx-check-box>
            </div>
        }

        <div class="modal-buttons">
            <dx-button
                class="cta-btn"
                type="danger"
                [text]="'COMMON.CANCEL' | translate"
                (click)="cancel()"
            ></dx-button>

            <dx-button
                class="cta-btn"
                type="normal"
                [text]="'SUBMIT-EXTERNAL-CERTIFICATE.SUBMIT-FOR-APPROVAL' | translate"
                [disabled]="
                    (certificate.trainingType == TrainingType.IDD || certificate.trainingType == TrainingType.Compliance) 
                    && !confirmSubmitting
                "
                (click)="submit()"
            ></dx-button>
        </div>
    </div>
</dx-popup>